import { Component, Inject, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-close-status',
    templateUrl: './close-status.component.html',
    styleUrls: ['./close-status.component.scss'],
    standalone: false // NOSONAR
})
export class CloseStatusComponent implements OnInit {

  routeName : string;
  unloadDate;
  unloadTime;
  Res: any;

  constructor(public dialogRef: MatDialogRef<CloseStatusComponent>, private  readonly dashboardService : DashboardService,@Inject(MAT_DIALOG_DATA) public dataStore: any,private readonly  DatePipe: DatePipe,) {
    console.info('datastore...',dataStore)
   }

  ngOnInit(): void {
    this.routeName = this.dataStore.node.data.main_route;
    const unloadDateTime = this.dataStore.node.data.unload_start;
    const unloadTime = unloadDateTime.substr(11,5);
    this.unloadTime = unloadTime;
    this.unloadDate = this.dataStore.node.data.unload_start;
    this.unloadDate = this.DatePipe.transform(
      this.unloadDate?.substring(0, 10),
      'yyyy-MM-dd'
    );
  }

  closeDialog(){
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  closeStatus(){
    const unloadDateTime = this.dayFormatter(this.unloadDate) ? `${this.dayFormatter(this.unloadDate)}${' '}${this.unloadTime}${':00'}` : ''
    console.info('datetime...',unloadDateTime)
      this.dashboardService.updateStatus(this.dataStore.node.data.route_id,unloadDateTime)?.subscribe((response) => {
        this.Res = response;
        if (this.Res == "success") {  // NOSONAR
          this.dialogRef?.close({
            event: 'CloseStatus',
            responseType: 'success',
          });
        } else {
          console.info('error')
          this.dialogRef?.close({
            event: 'CloseStatus',
            responseType: 'error',
          });
        }
      }, (err) => {
        console.info(err);
        this.dialogRef?.close({
          event: 'CloseStatus',
          responseType: 'error',
        });
      });
  }

  dayFormatter(val){
    if (val == null) {return '';}  // NOSONAR
    else {return moment(val).format('MM-DD-YYYY');}
  }

}
